import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Loader from "../component/Loader";
import PageHead from "../component/PageHead";
import { FALLBACK_AVATAR, fallbackTo, uploadUrl } from "../constants";

const Authors = () => {
  const [authors, setAuthors] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const getAuthors = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/users`);
        setAuthors(response.data || []);
      } catch (error) {
        console.log(error);
      }
      setIsLoading(false);
    };
    getAuthors();
  }, []);

  return (
    <div className="container">
      <PageHead
        num="A"
        label="Authors"
        line1="The people"
        line2="behind the posts."
        lead="Engineers sharing what they've built, broken and learned."
      >
        {!isLoading && <span className="eyebrow num">{String(authors.length).padStart(2, "0")} writers</span>}
      </PageHead>

      {isLoading ? (
        <Loader label="Loading authors…" />
      ) : authors.length ? (
        <div className="author-grid">
          {authors.map(({ _id: id, avatar, name, posts }, i) => (
            <Link
              className="author-card reveal"
              key={id}
              to={`/posts/users/${id}`}
              style={{ animationDelay: `${Math.min(i, 10) * 40}ms` }}
            >
              <span className="avatar avatar--lg">
                <img src={uploadUrl(avatar)} alt="" onError={fallbackTo(FALLBACK_AVATAR)} />
              </span>
              <div>
                <h3>{name}</h3>
                <p className="num">
                  {posts || 0} {posts === 1 ? "post" : "posts"}
                </p>
              </div>
            </Link>
          ))}
        </div>
      ) : (
        <div className="empty">
          <h3>No authors yet</h3>
          <p>Create an account and be the first to publish.</p>
          <Link to="/register" className="btn btn--primary">
            Get started
          </Link>
        </div>
      )}
    </div>
  );
};

export default Authors;
